import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import ProcessSteps from '../components/ProcessSteps';
import api from '../utils/ApiManager';

const PaymentSuccess = () => {
  const { t } = useTranslation('payment');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState(t('success.processing'));
  const bucketId = searchParams.get('bucket');

  useEffect(() => {
    const verifyPayment = async () => {
      if (!bucketId) {
        setMessage(t('success.missingBucket'));
        setTimeout(() => navigate('/dashboard'), 3000);
        return;
      }

      try {
        await new Promise(resolve => setTimeout(resolve, 2000));
        const response = await api.get(`/api/content/bucket/${bucketId}`);
        
        if (response.data.contents.every(content => content.status === 'paid')) {
          setMessage(t('success.completedMessage'));
          setTimeout(() => navigate('/dashboard'), 3000);
        } else {
          setMessage(t('success.delayedMessage'));
          setTimeout(() => navigate('/dashboard'), 3000);
        }
      } catch (error) {
        console.error('Error verifying payment:', error);
        setMessage(t('success.verificationError'));
        setTimeout(() => navigate('/dashboard'), 3000);
      }
    };

    verifyPayment();
  }, [bucketId, navigate, t]);

  return (
    <div>
      <Navbar />
      <div className="container mx-auto p-4 mt-16">
        <ProcessSteps currentStep={3} />
        <div className="min-h-screen flex items-center justify-center">
          <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
            <div className="text-center">
              <div className="mx-auto mb-4">
                <svg className="w-16 h-16 text-green-500 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">{t('success.title')}</h2>
              <p className="text-gray-600 mb-8">{message}</p>
              <button
                onClick={() => navigate('/dashboard')}
                className="bg-green-500 text-white px-6 py-2 rounded hover:bg-green-600 transition-colors"
              >
                {t('success.toDashboard')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;